const JsonRPC = require('./json_rpc');

class JsonRPCClient extends JsonRPC {

  constructor({
    url,
    options = null,
    beforeHandle = null,
    beforeSend = null
  } = {}) {
    super({
      url,
      options,
      WebSocket: require('ws'),
      beforeHandle,
      beforeSend
    });
  }
}

module.exports = JsonRPCClient;